import { header } from 'api/Auth/auth';
import axios from 'axios';
import { apiPaths } from 'constants/path';
import { tokenHeader } from 'functions/apiFunctions';
import { GetResultDiagnosisApiResponse, IDDiagnosisApi } from 'models/DCK/DCKApiTypes';
import { GetAssessmentAiResultResponse } from 'models/MindUp/MindUpApiTypes';

class PreciousAssessmentApi {
    async getAssessmentScriptByCode(assessmentCode: string, token: string): Promise<IDDiagnosisApi> {
        try {
            const response = await axios.get(apiPaths.findByCode + assessmentCode, {
                headers: tokenHeader(token),
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }
    async getAssessmentResultByDiagnosisId(diagnosisId: string, token: string): Promise<GetResultDiagnosisApiResponse> {
        try {
            const response = await axios.get(apiPaths.getResultDiagnosis + diagnosisId, {
                headers: tokenHeader(token),
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async getDiagnosis(url: string, token: string): Promise<GetAssessmentAiResultResponse> {
        try {
            const response = await axios.get(apiPaths.getDiagnosis + url, {
                headers: tokenHeader(token),
            });

            return response.data;
        } catch (error) {
            throw error;
        }
    }
}
export const mindUpAssessmentApi = new PreciousAssessmentApi();
